import { CheckCircle2, Clock, User, X } from "lucide-react";

const ControlsTab = ({ controlsData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Control Library</h3>
                  <p className="text-sm text-slate-500 mt-1">Configured policies and technical parameters.</p>
                </div>
              </div>
            <div className="grid grid-cols-1 gap-3">
              {controlsData.map((ctrl) => (
                <div key={ctrl.id} className="bg-white p-5 rounded-2xl ring-1 ring-slate-200/60 shadow-sm hover:ring-indigo-300/60 transition-all flex flex-col lg:flex-row lg:items-center gap-5">
                  
                  <div className="lg:w-1/3 space-y-2">
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-bold text-indigo-700 bg-indigo-50 ring-1 ring-indigo-200/50 px-2.5 py-1 rounded-md">{ctrl.id}</span>
                      <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-2 py-1 rounded uppercase tracking-wider">{ctrl.framework}</span>
                    </div>
                    <p className="text-base font-bold text-slate-900">{ctrl.title}</p>
                    <p className="text-xs font-medium text-slate-500">{ctrl.category}</p>
                  </div>

                  <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 bg-slate-50/50 p-4 rounded-xl border border-slate-100">
                    <div className="flex flex-col gap-1.5">
                      <span className="font-bold uppercase tracking-widest text-[10px] text-slate-400">Owner</span> 
                      <strong className="text-sm text-slate-800 flex items-center gap-1.5"><User size={14} className="text-slate-400"/> {ctrl.owner}</strong>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <span className="font-bold uppercase tracking-widest text-[10px] text-slate-400">Parameter</span> 
                      <strong className="text-sm text-slate-800 truncate" title={ctrl.parameter}>{ctrl.parameter}</strong>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <span className="font-bold uppercase tracking-widest text-[10px] text-slate-400">Frequency</span> 
                      <strong className="text-sm text-slate-800 flex items-center gap-1.5"><Clock size={14} className="text-slate-400"/> {ctrl.frequency}</strong>
                    </div>
                  </div>

                  <div className="shrink-0 flex justify-end">
                     <span className={`text-xs font-bold px-3 py-1.5 rounded-full ring-1 flex items-center gap-1.5 ${ctrl.status === 'Passing' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200' : 'bg-rose-50 text-rose-700 ring-rose-200'}`}>
                        {ctrl.status === 'Passing' ? <CheckCircle2 size={14}/> : <X size={14}/>} {ctrl.status}
                     </span>
                  </div>

                </div>
              ))}
            </div>
        </div>
    </>);
};

export default ControlsTab;